type UserRole =
  | 'READ_ONLY'
  | 'READ_WRITE'
  | 'ORGANISATION_ADMIN'
  | 'JAPETO_ADMIN'
  | 'SUPER_ADMIN';

export default UserRole;

const userRoleLabels: { [key in UserRole]: string } = {
  READ_ONLY: 'Viewer',
  READ_WRITE: 'Editor',
  ORGANISATION_ADMIN: 'Admin',
  JAPETO_ADMIN: 'Japeto Admin',
  SUPER_ADMIN: 'Super Admin'
};

export function getUserRoleLabel(role: UserRole): string {
  return userRoleLabels[role];
}
